import React from 'react';

const Loading = ({ size = 'medium', text = 'Loading...' }) => {
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8',
    large: 'w-12 h-12'
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
      <div className="flex flex-col items-center space-y-4">
        {/* Spinner */}
        <div className={`${sizeClasses[size]} border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin`}></div>
        
        {/* Loading text */}
        <div className="text-gray-600 font-medium animate-pulse">
          {text}
        </div>
        
        {/* Brand */}
        <div className="text-sm text-gray-400 mt-4">
          Lead Generation App
        </div>
      </div>
    </div>
  );
};

export default Loading;